import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW } from "const"
import { MtUser } from "server/models"
import { mtUsersRoute } from "client/parts/routes"
import { StoreType, addModal, setUserView } from "client/store"
import {
    Link,
    UserIcon,
    DateFormatter,
    TableColumn,
    TablePopover,
    TablePopoverData,
} from "client/components"

import AssignedAccounts from "../accounts/assigned"

const Columns = () => {
    const accountList = useSelector((state: StoreType) => state.account.accountList)
    const userAccountList = useSelector((state: StoreType) => state.accountUser.userAccountList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (user: MtUser) => {
                const href = `${mtUsersRoute}/${VIEW}/${user.id}`
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        <UserIcon user={user} size="md" />
                    </Link>
                )
            },
        },
        {
            field: "accounts",
            header: lang.accounts,
            cellMinWidth: "150px",
            formatter: (user: MtUser) => {
                if (!accountList || !userAccountList) return null

                const accountIds = userAccountList[user.id] || []
                const dataList: TablePopoverData[] = []
                accountIds.forEach((accountId) => {
                    const account = accountList[accountId]
                    dataList.push({
                        id: `${user.id}_${account.id}`,
                        title: account.name,
                    })
                })

                return (
                    <TablePopover
                        id={`userAccounts${user.id}`}
                        dataList={dataList}
                        placement="left"
                        title={lang.accounts}
                        editAccess
                        onClick={() => {
                            dispatch(setUserView(user))
                            dispatch(addModal({
                                key: "assignedUserAccounts",
                                content: <AssignedAccounts userId={user.id} />,
                            }))
                        }}
                    />
                )
            },
        },
        {
            field: "login",
            header: lang.login,
            sortable: true,
            cellMinWidth: "150px",
            cellMaxWidth: "300px",
        },
        {
            field: "email",
            header: lang.email,
            sortable: true,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (user: MtUser) => <DateFormatter date={user.createdAt} />,
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => true,
        },
    ]

    return columns
}
export default Columns
